import React from 'react'
import './style.css';
import { useSelector,useDispatch } from 'react-redux'
import currencyFormatter from 'currency-formatter'
import {toast} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';


toast.configure()
const Favourite = () => {

   const {allFavouriteItems} = useSelector(state => state.favouriteProducts);
   const dispatch = useDispatch()

   const favAdd = () => {
    toast.success("The Product have been added to cart",{
        position:toast.POSITION.TOP_CENTER
    })
   }

   const removefav = () => {
       toast.warn("The product have been removed",{
           position:toast.POSITION.TOP_CENTER
       })
   }
    return (
    <div className="favourite">
    <div className="container">
   
        
    {
        allFavouriteItems.length?
        <>
        <h2>Your Favourite Products</h2>
        {
        allFavouriteItems.map(product => (
            <div className="row" key={product.id}>    
            <div className="col-md-10 col-sm-12" >
                <div className="fav-content">
                    <div className="fav-img">
                        <img src={product.image} alt={product.title} />
                    </div>
                    <div className="fav-info">
                        <h3>{product.title}</h3>
                        <p>Price : {currencyFormatter.format(product.price, { code: 'USD' })}</p>
                        <span>{product.desc}</span>
                        
                       <div className="fav-btn">

                       
                       <button className="btn-add" 
                       onClick={()=>{dispatch({type:'FAV_TO_CART',prod:product})
                       favAdd()
                       }}>
                           
                           <i className="fa fa-shopping-cart"></i>
                            Add to cart
                        </button>
                        
                        
                        <button className="btn btn-danger" onClick={()=>{
                             dispatch({type:'REMOVE', id:product.id})
                             removefav()
                        }
                            }><i className="fas fa-trash-alt"></i>Remove</button>
                       </div>
                    </div>
                </div>
            </div> 
    </div>
        ))}
             </>
             :<h2 className="empty">you have no products</h2>
    }
            
    </div>
</div>
    )
}

export default Favourite
